var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * 发送验证码按钮
 */
import { CommonApi } from '@common/api/common';
import { Api } from '@common/application/utils/request';
import { Toast } from '@common/application/utils/ui/toast';
import { classNames } from '@common/application/utils/classnames';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Button } from '../button';
export const CaptchaButton = React.forwardRef(function CaptchaButton(props, ref) {
    const { text, className, disabled, callBack, areaCode, phone } = props;
    const { t } = useTranslation(['common']);
    const [disable, setDisable] = useState(false);
    const [second, setSecond] = useState(60);
    let timer;
    /** 发送验证码 */
    const sendCaptcha = () => __awaiter(this, void 0, void 0, function* () {
        const params = {
            areaCode,
            phone
        };
        try {
            const { data, message } = yield CommonApi.sendSmsCaptcha(params, { hideToast: true });
            const sessionUuid = data === null || data === void 0 ? void 0 : data.sessionUuid;
            if (sessionUuid) {
                Toast(t('captchaSend.sendCodeSuccess'), {
                    type: 'success'
                });
                setDisable(true);
                let time = 60;
                timer = setInterval(() => {
                    setSecond(--time);
                    if (time === 0) {
                        clearInterval(timer);
                        setDisable(false);
                        setSecond(60);
                    }
                }, 1000);
            }
            else {
                Toast(message);
            }
            callBack(sessionUuid);
        }
        catch (e) {
            Api.errorHandle(e);
        }
    });
    useImperativeHandle(ref, () => ({
        sendCaptcha
    }));
    useEffect(() => clearInterval(timer), []);
    return (_jsx(Button, Object.assign({ type: "button", disabled: disabled || disable, className: classNames('h-7.5 px-2.5 text-xs text-red bg-white  border-0 rounded-none hover:bg-red-light', className), onClick: sendCaptcha }, { children: disable
            ? `${text || t('captchaSend.sendCaptcha')}${second}s`
            : text || t('captchaSend.sendCaptcha') })));
});
